module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/flip-horizontal-92d275415f32a03c2d56990bd8798cba.svg";